export const Backdrop = (() => {
  let element: HTMLDivElement | null = null;
  let currentClass: string | null = null;
  let clickController: AbortController | null = null;

  function getOrCreate(): HTMLDivElement {
    if (!element) {
      element = document.querySelector<HTMLDivElement>('#backdrop');
    }
    if (!element) {
      element = document.createElement('div');
      element.id = 'backdrop';
      element.classList.add('backdrop');
      element.setAttribute('aria-hidden', 'true');
      document.body.appendChild(element);
      element.getBoundingClientRect(); // force reflow so CSS transition fires on first use
    }
    return element;
  }

  /**
   * Shows the backdrop. Swaps the modifier class if one is already active.
   * @param cssClass Optional BEM modifier class (e.g. `'backdrop-page'`, `'backdrop-content'`).
   */
  function show(cssClass?: string): void {
    const el = getOrCreate();

    if (currentClass) {
      el.classList.remove(currentClass);
    }

    if (cssClass) {
      el.classList.add(cssClass);
      currentClass = cssClass;
    }

    el.classList.add('backdrop-active');
  }

  /** Hides the backdrop and removes any active modifier class and click listener. */
  function hide(): void {
    if (!element) {
      return;
    }

    if (clickController) {
      clickController.abort();
      clickController = null;
    }

    if (currentClass) {
      element.classList.remove(currentClass);
      currentClass = null;
    }

    element.classList.remove('backdrop-active');
  }

  /**
   * Registers a one-time click handler on the backdrop. The click is stopped
   * from propagating so it does not reach other global handlers.
   * @param handler Called when the backdrop is clicked.
   */
  function addClickListener(handler: EventListener): void {
    if (!clickController) {
      clickController = new AbortController();
    }
    getOrCreate().addEventListener(
      'click',
      (evt) => {
        evt.stopPropagation();
        handler(evt);
      },
      {
        once: true,
        signal: clickController.signal
      }
    );
  }

  return { show, hide, addClickListener };
})();
